import { Center, Spinner } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export const Loader = ({ height = 400, width = 400 }) => {
  const { t } = useTranslation()
  return (
    // role="status" makes this a polite live region; the aria-label gives
    // screen-reader users a spoken "loading" cue the spinner alone can't (WCAG 4.1.3).
    <Center w={width} h={height} role="status" aria-label={t('global:loading')}>
      <Spinner
        color="brand.fg"
        size="xl"
        borderWidth="4px"
        animationDuration="0.7s"
      />
    </Center>
  )
}
